<template>
    <toolbar-option type="stacked">
        <template v-if="slider" slot="secondary">
            <dropdown
                :value="side"
                :options="sideOptions"
                native
                @input="onSideInput"
            />
        </template>

        <template slot="secondary-2">
            <dropdown
                :value="unit"
                :options="unitOptions"
                native
                @input="onUnitInput"
            />
        </template>

        <template slot="primary">
            <collapse id="control-border-radius" v-model="slider">
                <slider
                    :value="sliderIndex"
                    :values="themeObjectValues"
                    @input="onInput"
                />
            </collapse>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

export default {
    name: 'border-radius',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Border Radius',
            defaultUnit: 'rem',
            tailwindDefinitionProp: 'borderRadius',
        };
    },
};
</script>
